import { renderIsomorphicComponent, renderComponent, renderBreakingNews } from "@quintype/framework/client/start";
import { pickComponent } from "../isomorphic/pick-component";
import { BreakingNewsView } from "../isomorphic/components/atoms/breaking-news-view";
import { Header } from "../isomorphic/components/header";
import { Footer } from "../isomorphic/components/layouts/footer";
import { LoadingIndicatorComponent } from "../isomorphic/components/basic/loading-indicator";
import AdsBootstrapper from "../isomorphic/components/atoms/ads-bootstrapper";

export function preRenderApplication(store) {
  const hydrate = {
    hydrate: !global.qtLoadedFromShell
  };

  renderComponent(Header, "header", store, hydrate);
  renderComponent(Footer, "footer", store, hydrate);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
  renderComponent(AdsBootstrapper, "ads-bootstrapper-root", store);
  renderBreakingNews("breaking-news-container", store, BreakingNewsView, hydrate);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell
  });
}
